import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import appointmentStyles from "../../../styles/userDetails/appointmentScheduler.module.css";
import { useNavigate } from 'react-router-dom';
import getBranchesList from '../../../utility/features/api_clients/reports/getBranchesList';
import getPostalCodebyBranchId from '../../../utility/features/api_clients/reports/getPostalCodeByBranch';
import getBranchDashBoardData from '../../../utility/features/api_clients/reports/getBranchDashBoardData';
import '../reports/reports.css';
const Reports = () => {
    const navigate = useNavigate();
    const USA_TIMEZONE = 'America/New_York';

    const toUsaDateOnly = (date) => {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: USA_TIMEZONE,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).formatToParts(date);

        const year = parts.find((p) => p.type === 'year')?.value;
        const month = parts.find((p) => p.type === 'month')?.value;
        const day = parts.find((p) => p.type === 'day')?.value;
        return `${year}-${month}-${day}`;
    };

    const toDateOnlyFromSelectedDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getUsaCurrentDate = () => {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: USA_TIMEZONE,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).formatToParts(new Date());

        const year = Number(parts.find((p) => p.type === 'year')?.value);
        const month = Number(parts.find((p) => p.type === 'month')?.value);
        const day = Number(parts.find((p) => p.type === 'day')?.value);

        return new Date(year, month - 1, day);
    };

    const addWorkingDays = (fromDate, daysToAdd) => {
        const result = new Date(fromDate);
        let addedDays = 0;

        while (addedDays < daysToAdd) {
            result.setDate(result.getDate() + 1);
            const dayOfWeek = result.getDay();
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                addedDays += 1;
            }
        }

        return result;
    };

    const initialStartDate = getUsaCurrentDate();
    const [appointments, setAppointments] = useState([
       
    ]);

    const [selectedBranch, setSelectedBranch] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedZipCode, setSelectedZipCode] = useState([]);
    const [zipCode, setZipCode] = useState('');
    const [postalCodes, setPostalCodes] = useState([]);
    const [loadingPostalCodes, setLoadingPostalCodes] = useState(false);
    const [startDate, setStartDate] = useState(initialStartDate);
    const [endDate, setEndDate] = useState(addWorkingDays(initialStartDate, 6));
    const [branches, setBranches] = useState([]);
    const [loadingBranches, setLoadingBranches] = useState(true);
    const [loadingSearch, setLoadingSearch] = useState(false);

    useEffect(() => {
        if (startDate) {
            setEndDate(addWorkingDays(startDate, 6));
        }
    }, [startDate]);

   
    const [activePage, setActivePage] = useState(1);
    const ITEMS_PER_PAGE = 10;
    const totalPages = Math.ceil(appointments?.length / ITEMS_PER_PAGE);
    const startIndex = (activePage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedAppointments = appointments?.slice(startIndex, endIndex);
    
    const handlePageClick = (pageNum) => {
        setActivePage(pageNum);
    };

     // Fetch branches on component mount
    useEffect(() => {
        const fetchBranches = async () => {
            try {
                setLoadingBranches(true);
                const response = await getBranchesList();
                if (response && !response.error && response.data) {
                    setBranches(response.data);
                } else {
                    console.error('Failed to fetch branches:', response?.message);
                    setBranches([]);
                }
            } catch (error) {
                console.error('Error fetching branches:', error);
                setBranches([]);
            } finally {
                setLoadingBranches(false);
            }
        };

        fetchBranches();
    }, []);

    // Store all appointments for client-side filtering
    const [allAppointments, setAllAppointments] = useState([]);
    useEffect(() => {
        const fetchAppointments = async () => {
            setLoadingSearch(true);
            try {
                const requestData = {
                    branchID: 0, // 0 for all branches
                    startDate: toDateOnlyFromSelectedDate(startDate),
                    endDate: toDateOnlyFromSelectedDate(endDate)
                };
                const response = await getBranchDashBoardData(requestData);
                if (response && !response.error && response.data) {
                    const appointmentsData = Array.isArray(response.data) ? response.data : [];
                    setAllAppointments(appointmentsData);
                    setAppointments(appointmentsData);
                } else {
                    console.error('Failed to fetch appointments:', response?.message);
                    alert(response?.message || 'Failed to fetch appointments');
                    setAllAppointments([]);
                    setAppointments([]);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                alert('An error occurred while fetching appointments');
                setAllAppointments([]);
                setAppointments([]);
            } finally {
                setLoadingSearch(false);
            }
        };
        fetchAppointments();
    }, []);

    // Handler for branch selection (client-side filter)
    const handleBranchChange = (selected) => {
        setSelectedBranch(selected);
        const branchId = selected.length > 0 ? (selected[0].branchID || selected[0].id) : 0;
        setSearchTerm(branchId ? String(branchId) : '');
        setActivePage(1);
        if (branchId) {
            setAppointments(allAppointments.filter(a => (a.branchId || a.branchID) === branchId));
        } else {
            setAppointments(allAppointments);
        }
    };

    return (
        <div className="container p-0">
            <div className="position-relative d-flex justify-content-between align-items-center">
            </div>
            <div className='row py-2'>
                <div className='col-12 mb-2 mb-md-0 d-flex flex-column flex-md-row align-items-md-end'>
                    <label className='form-label'>Search by Branch :   </label>
                    <div style={{marginLeft : '10px'}}>
                        <Typeahead 
                            id="branch-typeahead"
                            labelKey={(option) => `${option.branchID || option.id}${option.branchName ? ` - ${option.branchName}` : ''}`}
                            options={branches}
                            placeholder={loadingBranches ? 'Loading branches...' : 'Select or search branch...'}
                            selected={selectedBranch}
                            inputProps={{ maxLength: 4 }}
                            onChange={handleBranchChange}
                            disabled={loadingBranches}
                            clearButton
                            emptyLabel="No branches found"
                            positionFixed
                        />
                    </div>
                </div>
                {/* <div className='col-12 col-md-2 mb-2 mb-md-0'>
                    <label className='form-label'>&nbsp;</label>
                    <button
                        type="button"
                        className={`btn btn-primary w-100 ${appointmentStyles["bg-green"]}`}
                        onClick={handleSearch}
                        disabled={loadingSearch || !searchTerm}
                    >
                        {loadingSearch ? 'Searching...' : 'Search'}
                    </button>
                </div> */}
                
            </div>


            {/* </div> */}

            <div className={appointmentStyles["table-theme"]}>
                <div className={`table-responsive ${appointmentStyles["table-card"]}`}>
                    <table className={`w-100 ${appointmentStyles["table"]} align-middle`}>
                        <thead>
                            <tr>
                                <th scope="col">Branch ID</th>
                                <th scope="col" className="compact-name">Name</th>
                                <th scope="col" className="compact-email">Email</th>
                                <th scope="col" className="compact-address">Address</th>
                                <th scope="col">Appt Date – Time – (Type)</th>
                                <th scope="col">Phone Num</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingSearch ? (
                                <tr>
                                    <td colSpan="6" className="text-center py-4">
                                        Loading appointments...
                                    </td>
                                </tr>
                            ) : appointments.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="text-center py-4">
                                       Please adjust your search filters to see the appointments.
                                    </td>
                                </tr>
                            ) : (
                                paginatedAppointments.map((appointment, index) => {
                                    return (
                                        <tr key={`${appointment.branchId || appointment.branchID}-${index}`}>
                                            <td>{appointment.branchId || appointment.branchID}</td>
                                            <td className="compact-name" title={appointment.name || appointment.customerName}>{appointment.name || appointment.customerName}</td>
                                            <td className="compact-email" title={appointment.email || appointment.customerEmail}>{appointment.email || appointment.customerEmail}</td>
                                            <td  title={appointment.address || appointment.customerAddress}>{appointment.address || appointment.customerAddress}</td>
                                            <td>{appointment.apptDate || appointment.appointmentDate} – {appointment.apptTime || appointment.appointmentTime} ({appointment.appoinmentType})</td>
                                            <td>{appointment.phoneNum || appointment.customerPhone}</td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {totalPages > 1 && (
                <div className={appointmentStyles['pagination-wrapper']}>
                    <div className={appointmentStyles['pagination']}>
                        <button 
                            className={`${appointmentStyles["page-btn"]} ${appointmentStyles['nav-btn']}`} 
                            onClick={() => handlePageClick(activePage - 1)}
                            disabled={activePage === 1}
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>

                        {activePage > 3 && (
                            <>
                                <button className={appointmentStyles["page-btn"]} onClick={() => handlePageClick(1)}>1</button>
                                {activePage > 4 && <span className={appointmentStyles["ellipsis"]}>...</span>}
                            </>
                        )}

                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter((num) => num >= activePage - 2 && num <= activePage + 2)
                            .map((num) => (
                                <button 
                                    key={num} 
                                    className={`${appointmentStyles["page-btn"]} ${num === activePage ? appointmentStyles["active"] : ""}`} 
                                    onClick={() => handlePageClick(num)}
                                >
                                    {num}
                                </button>
                            ))}

                        {activePage < totalPages - 2 && (
                            <>
                                {activePage < totalPages - 3 && <span className={appointmentStyles["ellipsis"]}>...</span>}
                                <button className={appointmentStyles["page-btn"]} onClick={() => handlePageClick(totalPages)}>{totalPages}</button>
                            </>
                        )}

                        <button 
                            className={`${appointmentStyles["page-btn"]} ${appointmentStyles['nav-btn']}`} 
                            onClick={() => handlePageClick(activePage + 1)}
                            disabled={activePage === totalPages}
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>

                    <div className={appointmentStyles['pagination-info']}>
                        <span>Showing {startIndex + 1} - {Math.min(endIndex, appointments?.length)} of {appointments?.length} appointments</span>
                    </div>
                </div>
            )}
        </div>
    );
};


export default Reports;